export const SECRETS = {
  X_API_KEY: "d5d6e20b-7a6e-4353-bfa9-d9e08bfc5a36",
  API_URL: "arcadia-typerace.herokuapp.com"
};
